module.exports = __webpack_public_path__ + "static/media/dot.a721bb3f.png";